export const SET_CONFIRM_EMAIL_STATUS = "SET_CONFIRM_EMAIL_STATUS";
export const SET_RELATIVE_DATA = "SET_RELATIVE_DATA";
export const SET_FIELD_VALUE = "SET_FIELD_VALUE";
export const SET_ACCEPT_TERMS_STATUS = "SET_ACCEPT_TERMS_STATUS";
